/* AGC Mobile Header Scroll Behavior — Director-approved 2026-04-30
   Mobile (<= 749px) global behavior:
   - Scroll DOWN past threshold: header hides (translateY)
   - Scroll UP: header re-appears with solid white background + color logo
   - Within TOP_BUFFER of page top: revert to default header state
     (transparent on PDP, normal on other pages). */
(function(){
  if (window.__agcMobileHeaderWired) return;
  window.__agcMobileHeaderWired = true;

  var mql = window.matchMedia('(max-width: 749px)');
  var header = null;
  var lastY = 0;
  var ticking = false;
  var THRESH = 8;
  var TOP_BUFFER = 50;
  var DOWN_TRIGGER = 80;

  function getHeader(){
    return document.querySelector('.section-header');
  }

  function update(){
    if (!header) header = getHeader();
    if (!header) { ticking = false; return; }
    var y = window.scrollY || window.pageYOffset || 0;
    var dy = y - lastY;

    if (y <= TOP_BUFFER) {
      header.classList.remove('agc-header-hidden');
      header.classList.remove('agc-header-revealed');
      lastY = y;
    } else if (Math.abs(dy) > THRESH) {
      if (dy > 0 && y > DOWN_TRIGGER) {
        header.classList.add('agc-header-hidden');
        header.classList.remove('agc-header-revealed');
      } else if (dy < 0) {
        header.classList.remove('agc-header-hidden');
        header.classList.add('agc-header-revealed');
      }
      lastY = y;
    }
    ticking = false;
  }

  function onScroll(){
    if (!mql.matches) return;
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function onResize(){
    if (!mql.matches && header) {
      header.classList.remove('agc-header-hidden');
      header.classList.remove('agc-header-revealed');
    }
  }

  /* Sticky ATC awareness: when <sticky-atc> is visible (loses .invisible),
     mark body so chat-button can shift up. */
  function watchStickyAtc(){
    function pickAndWatch(){
      var sticky = document.querySelector('sticky-atc.sticky-atc');
      if (!sticky) return false;
      function sync(){
        var visible = !sticky.classList.contains('invisible');
        document.body.classList.toggle('agc-sticky-atc-visible', visible);
      }
      sync();
      try {
        new MutationObserver(sync).observe(sticky, { attributes: true, attributeFilter: ['class','style'] });
      } catch (_) {}
      return true;
    }
    if (pickAndWatch()) return;
    // Retry after late DOM upgrade
    setTimeout(pickAndWatch, 250);
    setTimeout(pickAndWatch, 1000);
    if (window.MutationObserver){
      var bodyMo = new MutationObserver(function(){ if (pickAndWatch()) bodyMo.disconnect(); });
      bodyMo.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init(){
    header = getHeader();
    lastY = window.scrollY || 0;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    watchStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
